export { Remediate } from './remediate';
export { BaselineComponent } from './baseline.component';
export const href = 'https://learn.microsoft.com/en-us/graph/api/resources/crosstenantaccesspolicy-overview';
